<article class="related-search sim-gallery">
    <div class="container">       
        <div class="simmer-animation sim-heading sim-2-3-heading"></div>
        <div class="row custome-set">
            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>
            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>

            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>
            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>
            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>

            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>
            <div class="series-box ratio-2-3-simmer">
                <div class="simmer-animation series-img"></div>
                <div class="series-content">
                    <div class="simmer-animation w-100 simmer-animation sim-date"></div>
                </div>
            </div>
        </div>
    </div>
</article>

